import type { CSSProperties } from 'react';
import { cn } from '@/lib/cn';

export function Skeleton({
    className,
    style,
}: {
    className?: string;
    style?: CSSProperties;
}) {
    return (
        <div
            aria-hidden
            style={style}
            className={cn('animate-pulse rounded bg-surface-muted', className)}
        />
    );
}
